export default function DownloadApp() {
  return (
    <section id="download" className="bg-white py-16 md:py-24 px-4 sm:px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16">

        {/* Left: Info */}
        <div className="flex-1 flex flex-col gap-5 md:gap-6 items-center md:items-start text-center md:text-left w-full">
          <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center">
            <img
              src="https://glovoapp.com/_next/static/media/download-icon.475cc763.svg"
              alt="Download"
              className="w-full h-full object-contain"
            />
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
            Download the app
          </h2>
          <p className="text-gray-500 text-sm md:text-base leading-relaxed max-w-md">
            Order your fav meal and earn digital rewards on the Sweetplate app. Available for iOS and Android.
          </p>
          <div className="flex items-center gap-3 flex-wrap justify-center md:justify-start">
           
            <a
              href="https://play.google.com/store/apps/details?id=com.sweetplate.user"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer hover:opacity-80 transition-opacity"
            >
              <img
                src="https://glovoapp.com/_next/static/media/google-button.4b60c502.svg"
                alt="Get it on Google Play"
                className="h-10 md:h-12 w-auto"
              />
            </a>
          </div>
          <div className="flex items-center gap-3 flex-wrap justify-center md:justify-start">
            <div className="flex items-center gap-2 bg-gray-50 rounded-xl px-4 py-3">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-star-fill text-[#FFCD1A] text-base" />
              </div>
              <div>
                <p className="text-sm font-bold text-gray-800">4.8 / 5</p>
                <p className="text-xs text-gray-500">App Rating</p>
              </div>
            </div>
            <div className="flex items-center gap-2 bg-gray-50 rounded-xl px-4 py-3">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-download-line text-[#009E81] text-base" />
              </div>
              <div>
                <p className="text-sm font-bold text-gray-800">50K+</p>
                <p className="text-xs text-gray-500">Downloads</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Phone mockup */}
        <div className="flex-1 flex justify-center">
          <img
            src="https://glovoapp.com/_next/static/media/download-app.2ab3fe41.png"
            alt="Sweetplate App"
            className="w-full max-w-[280px] sm:max-w-[360px] md:max-w-[500px] object-contain"
          />
        </div>
      </div>
    </section>
  );
}
